module.exports = __webpack_public_path__ + "media/images/icons/star-icon_white-37049653dea92bb02d9cc8746cbfe11b.svg";